import simpleRegistration from "~/store/simpleRegistration";

export function useSimpleRegistration() {
  return simpleRegistration;
}
